import { IUserSettingsClient } from "@multiweb/clients/userSettings";
import { IAssignedRole, IAssignedRoles } from "@multiweb/types/contracts";
import { CancellationToken } from "@multiweb/types/multiweb";
import { AttrValueReader } from "OW.Remoting/Remoting/AttrValueReader";
import { IRole } from "OW.Remoting/Remoting/IRolesAndICompetences";
import { getCancellationTokenAsRequestContext } from "OW.Remoting/Remoting/RequestContext";
import { UserSettingsClient } from "./UserSettingsClient";

/**
 * @internal
 */
export class LegacyUpTo2002UserSettingsClient extends UserSettingsClient implements IUserSettingsClient {
    public override async getAssignedRoles(cancellationToken?: CancellationToken): Promise<IAssignedRoles> {
        const roles: IAssignedRoles = {};
        const result = await this._dataReaderClient.getDataRowsWithParams("CRole_uzivatele_pohled", ["ID", "Role_uzivatelem.ID", "Nazev_role", "Fyzicke_jmeno_role", "Implicitni_role"], "ID <> 0 AND Uzivatel_rolemi = $userid ", { params: ["RoleSettingsProfile"], dataLength: -1 }, undefined, getCancellationTokenAsRequestContext(cancellationToken));
        for (const row of result) {
            const role = {
                id: AttrValueReader.readRow(row, "Role_uzivatelem.ID"),
                implicit: AttrValueReader.readRow(row, "Implicitni_role"),
                active: null,
                name: AttrValueReader.readRow(row, "Nazev_role"),
                code: AttrValueReader.readRow(row, "Fyzicke_jmeno_role"),
                userRoleId: AttrValueReader.readRow(row, "ID"),
                competenceRanges: [],
            } as IAssignedRole;
            roles[role.id.toString()] = role;
        }

        return roles;
    }

    public override async setActiveUserRoleRanges(_userRoles: IRole[]): Promise<void> {
        return Promise.resolve();
    }
}
